import LoaderPage from "src/components/Loader/LoaderPage";
import Layout from ".";

const LoaderLayout = () => {
  return (
    <Layout className="" title={"Loading..."}>
      <LoaderPage />
    </Layout>
  );
};

export default LoaderLayout;
